var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3023 18.0484C20.5804 16.7703 22.6526 16.7703 23.9306 18.0484L40.9915 35.1092L58.0523 18.0484C59.3304 16.7703 61.4026 16.7703 62.6806 18.0484C63.9587 19.3265 63.9587 21.3987 62.6806 22.6767L45.6198 39.7376L62.6806 56.7984C63.9587 58.0765 63.9587 60.1487 62.6806 61.4267C61.4026 62.7048 59.3304 62.7048 58.0523 61.4267L40.9915 44.3659L22.6806 62.6767C21.4026 63.9548 19.3304 63.9548 18.0523 62.6767C16.7742 61.3987 16.7742 59.3265 18.0523 58.0484L36.3631 39.7376L19.3023 22.6767C18.0242 21.3987 18.0242 19.3265 19.3023 18.0484Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/red-X.065217e3d6dbfa474e669c67ec3821eb.svg";
export { ForwardRef as ReactComponent };